<script setup lang="ts">
/* eslint-disable max-len */
export interface IconNotFoundProps {
  isDarkTheme?: boolean;
}
const props = withDefaults(defineProps<IconNotFoundProps>(), { isDarkTheme: true });
</script>

<template>
  <template v-if="props.isDarkTheme">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="289"
      height="160"
      viewBox="0 0 159 88"
    >
      <defs>
        <circle id="a" cx="7" cy="7" r="7" />
        <circle id="b" cx="7" cy="7" r="7" />
        <circle id="c" cx="7" cy="7" r="7" />
      </defs>
      <g fill="none" fill-rule="evenodd">
        <g transform="translate(0 15)">
          <rect width="49" height="59" fill="#1C2535" rx="1.296" />
          <rect width="35" height="5" x="7" y="33" fill="#2C374B" rx=".648" />
          <rect width="27.317" height="5" x="7" y="42" fill="#2C374B" rx=".648" />
          <use xlink:href="#a" fill="#2C374B" transform="translate(17 11)" />
        </g>
        <g transform="translate(55 15)">
          <rect width="49" height="59" fill="#1C2535" rx="1.296" />
          <rect width="35" height="5" x="7" y="33" fill="#2C374B" rx=".648" />
          <rect width="27.317" height="5" x="7" y="42" fill="#2C374B" rx=".648" />
          <use xlink:href="#b" fill="#2C374B" transform="translate(17 11)" />
        </g>
        <g transform="translate(110 15)">
          <rect width="49" height="59" fill="#1C2535" rx="1.296" />
          <rect width="35" height="5" x="7" y="33" fill="#2C374B" rx=".648" />
          <rect width="27.317" height="5" x="7" y="42" fill="#2C374B" rx=".648" />
          <use xlink:href="#c" fill="#2C374B" transform="translate(17 11)" />
        </g>
        <path
          fill="#A9B7D1"
          d="M68.633 60.998c-15.444 0-27.965-12.603-27.965-28.149 0-15.547 12.52-28.15 27.965-28.15 15.444 0 27.965 12.603 27.965 28.15 0 15.546-12.52 28.149-27.965 28.149m25.704-7.98c.04-.042.087-.075.132-.11a32.84 32.84 0 0 0 6.798-20.059C101.267 14.707 86.656 0 68.633 0S36 14.707 36 32.849c0 18.142 14.61 32.849 32.633 32.849 7.474 0 14.354-2.539 19.856-6.794l5.848-5.886"
        />
        <path
          fill="#7787A5"
          d="M95.226 52.653c.316 0 .633.12.875.365l1.47 1.479c-.906.619-2.518 2.105-4.041 3.656a60.62 60.62 0 0 0-.344.353l-.105.11c.148-.155.298-.309.449-.462 1.527-1.554 3.138-3.039 4.042-3.656.28-.192.495-.302.616-.302.016 0 .03.002.043.006l.014.007.018.012-.013-.01a.072.072 0 0 1 .015.01l.002.003 22.981 23.384a6.128 6.128 0 0 1 .983 1.314l.057.106a6.444 6.444 0 0 1 .115.23 6.12 6.12 0 0 1 .532 1.756l.016.119a5.787 5.787 0 0 1 .044.533l.005.246c0 .117-.003.233-.01.35l-.012.177a7.642 7.642 0 0 1-.042.361 5.893 5.893 0 0 1-.188.865 6.067 6.067 0 0 1-.398 1.011l-.062.12a5.315 5.315 0 0 1-.058.107l-.086.15a4.588 4.588 0 0 1-.13.209 5.47 5.47 0 0 1-.342.475 6.157 6.157 0 0 1-.424.48 5.908 5.908 0 0 1-8.278.178l-.182-.178-22.98-23.384c-.073-.074-.01-.267.156-.545a8.64 8.64 0 0 1 .083-.134l-.083.134-1.537-1.546a1.262 1.262 0 0 1-.09-1.674l.09-.102.062-.062 3.775-3.8 2.073-2.086c.04-.042.087-.075.132-.11.224-.17.49-.255.757-.255Z"
        />
      </g>
    </svg>
  </template>
  <template v-else>
    <svg width="289" height="160" viewBox="0 0 217 120" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs>
        <ellipse id="ujyk7ctoha" cx="9.553" cy="9.545" rx="9.553" ry="9.545" />
        <ellipse id="fdmmxpau6b" cx="9.553" cy="9.545" rx="9.553" ry="9.545" />
        <ellipse id="uu7ci4xy3c" cx="9.553" cy="9.545" rx="9.553" ry="9.545" />
      </defs>
      <g fill="none" fill-rule="evenodd">
        <g transform="translate(0 20.455)">
          <rect fill="#EEE" width="66.874" height="80.455" rx="1.767" />
          <rect fill="#E4E3E3" x="9.553" y="45" width="47.767" height="6.818" rx=".883" />
          <rect fill="#E4E3E3" x="9.553" y="57.273" width="37.282" height="6.818" rx=".883" />
          <use fill="#E4E3E3" xlink:href="#ujyk7ctoha" transform="translate(23.201 15)" />
        </g>
        <g transform="translate(75.063 20.455)">
          <rect fill="#EEE" width="66.874" height="80.455" rx="1.767" />
          <rect fill="#E4E3E3" x="9.553" y="45" width="47.767" height="6.818" rx=".883" />
          <rect fill="#E4E3E3" x="9.553" y="57.273" width="37.282" height="6.818" rx=".883" />
          <use fill="#E4E3E3" xlink:href="#fdmmxpau6b" transform="translate(23.201 15)" />
        </g>
        <g transform="translate(150.126 20.455)">
          <rect fill="#EEE" width="66.874" height="80.455" rx="1.767" />
          <rect fill="#E4E3E3" x="9.553" y="45" width="47.767" height="6.818" rx=".883" />
          <rect fill="#E4E3E3" x="9.553" y="57.273" width="37.282" height="6.818" rx=".883" />
          <use fill="#E4E3E3" xlink:href="#uu7ci4xy3c" transform="translate(23.201 15)" />
        </g>
        <path d="M93.669 83.179c-21.078 0-38.166-17.186-38.166-38.385 0-21.2 17.088-38.385 38.166-38.385 21.078 0 38.166 17.185 38.166 38.385S114.747 83.18 93.669 83.18m35.08-10.882c.056-.057.119-.102.18-.149a44.757 44.757 0 0 0 9.278-27.354C138.207 20.055 118.267 0 93.669 0 69.072 0 49.132 20.055 49.132 44.794c0 24.739 19.94 44.794 44.537 44.794 10.2 0 19.59-3.462 27.1-9.264l7.98-8.027" fill="#BABBBE" />
        <path d="M120.684 82.83a1.719 1.719 0 0 1 0-2.422l.084-.084 5.152-5.183 2.829-2.844c.056-.057.119-.102.18-.149.305-.232.67-.349 1.033-.349.432 0 .864.165 1.194.498l2.006 2.017c-1.235.844-3.435 2.87-5.515 4.986l-.274-.276.275.277c2.083-2.12 4.282-4.144 5.516-4.985l.067-.045.043-.03-.043.029.044-.029a5.051 5.051 0 0 1 .371-.22 2.042 2.042 0 0 1 .11-.051l.04-.017a1.125 1.125 0 0 1 .122-.039.49.49 0 0 1 .078-.01l.008-.001.037.003a.156.156 0 0 1 .032.009l.022.011.018.016 31.364 31.887.19.2.069.075a8.44 8.44 0 0 1 .625.786l.009.013.153.228a8.269 8.269 0 0 1 .452.788l.06.121a9.256 9.256 0 0 1 .131.286c.077.176.148.355.213.536l.021.061a8.383 8.383 0 0 1 .459 2.377l.004.1.005.299-.002.099v.1l-.003.064v.035l-.001-.029-.003.127a7.693 7.693 0 0 1-.02.296 8.44 8.44 0 0 1-.203 1.277l-.048.19a8.384 8.384 0 0 1-.213.687l-.074.199a8.236 8.236 0 0 1-1.041 1.904l-.078.105a7.381 7.381 0 0 1-.284.354l-.123.143-.089.098a8.07 8.07 0 0 1-11.755.22l-31.364-31.887c-.099-.1-.012-.364.213-.743l-2.096-2.108z" fill="#ACADAF" />
      </g>
    </svg>
  </template>
</template>
